/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_312f105a"]'><div :class='["dialog-icon-passenger-demo"]'><cube-button @_click="onClickDialog">Dialog - head-icon</cube-button><cube-dialog ref="__mpx_ref_dialogWithHeadIcon__" type="alert" headIcon="https://dpubstatic.udache.com/static/dpubimg/f6abf7d7-e7a9-4c2b-8fc5-78085691220b.png" title="我是标题" content="我是内容" confirmBtn="我知道了"></cube-dialog></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_312f105a"}'>
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_312f105a"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_312f105a"}
  /** script content **/
  require("./dialog-head-icon.mpx.js?isComponent&outputPath=components%2Fdialog-head-icon312f105a%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./dialog-head-icon.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fdialog-head-icon312f105a%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_312f105a"],
    ctorType: "component",
    outputPath: "components/dialog-head-icon312f105a/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex")),'cube-dialog':getComponent(require("../../../packages/mpx-cube-ui/src/components/dialog/index.mpx?isComponent&outputPath=components%2Findex8b435562%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>